/**
 *  Reset script file
**/

import userService from '@/api/userService'
import i18n from '@/i18n'
import siteConfig from '@/mixins/siteConfig'

export default {
  name: 'Reset',
  mixins: [
    siteConfig
  ],
  components: {
    ResetPasswordModal: () => import('@/components/reset-password-modal/ResetPasswordModal.vue')
  },
  props: {},
  data () {
    return {
      password: null,
      repeatPassword: null,
      loading: false,
      error: null,
      success: false
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    passwordValid () {
      return this.password && this.repeatPassword && this.password === this.repeatPassword
    },
    passwordLengthValid () {
      return this.password && this.password.length >= 8
    },
    token () {
      return this.$route.params.token.toString()
    },
    isValidToken () {
      return this.token && this.token.length === 32
    }
  },
  mounted () {
    if (!this.isValidToken) {
      this.$router.push('/login')
    }
  },
  methods: {
    async resetPassword () {
      this.loading = true
      this.error = null
      try {
        if (!this.passwordValid) {
          throw new Error(i18n.t('PASSWORD_MUST_MATCH'))
        }

        if (!this.passwordLengthValid) {
          throw new Error(i18n.t('MIN_PASSWORD_SIZE'))
        }

        await userService.confirmResetPassword(this.token, this.password)

        this.success = true
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[reset.js] ', err)
        this.error = err.message === 'Request failed with status code 500' ? i18n.t('INVALID_SIZE') : err.message
        this.success = false
        this.repeatPassword = ''
        this.password = ''
      }
      this.loading = false
    }
  }
}
